import { jitsiLocalStorage } from '@jitsi/js-utils';
import React, { Component } from 'react';

import { Dialog } from '../../base/dialog';
import { translate } from '../../base/i18n';
import { connect } from '../../base/redux';

import VideoQualitySlider from './VideoQualitySlider';

/**
 * Implements a React {@link Component} which displays the component
 * {@code VideoQualitySlider} in a dialog.
 *
 * @augments Component
 */
class VideoQualityDialog extends Component {

    /** * constructor for VideoQualityDialog */
    constructor(props) {
        super(props);

        const storedValue = jitsiLocalStorage.getItem('features/video-quality-checked');
        const initialChecked = storedValue === 'true';

        this.state = {
            isChecked: initialChecked
        };

        this._onHandleChange = this._onHandleChange.bind(this);
        this._onSubmit = this._onSubmit.bind(this);
    }

    /**
     * handle change for checkbox
     */
    _onHandleChange(event) {
        const value = event.target.checked;
        const { _preferredVideoQuality } = this.props;

        this.setState({ isChecked: value });

        if (value) {
            jitsiLocalStorage.setItem('features/video-quality-checked', 'true');
            if (typeof _preferredVideoQuality !== 'undefined') {
                jitsiLocalStorage.setItem(
                    'features/video-quality-persistent-storage',
                    JSON.stringify({
                        persistedPrefferedVideoQuality: _preferredVideoQuality
                    })
                );
            }
        } else {
            jitsiLocalStorage.setItem('features/video-quality-checked', 'false');
            jitsiLocalStorage.removeItem('features/video-quality-persistent-storage');
        }
    }

    /**
     * Handles the submit action when the dialog is closed / done.
     *
     * @returns {boolean}
     */
    _onSubmit() {
        const { _preferredVideoQuality } = this.props;
        const { isChecked } = this.state;

        if (isChecked) {
            jitsiLocalStorage.setItem('features/video-quality-checked', 'true');
            if (typeof _preferredVideoQuality !== 'undefined') {
                jitsiLocalStorage.setItem(
                    'features/video-quality-persistent-storage',
                    JSON.stringify({
                        persistedPrefferedVideoQuality: _preferredVideoQuality
                    })
                );
            }
        } else {
            jitsiLocalStorage.setItem('features/video-quality-checked', 'false');
            jitsiLocalStorage.removeItem('features/video-quality-persistent-storage');
        }

        return true;
    }

    /** * Implements React's {@link Component#render()}.
     *
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _customResolution, t } = this.props;
        const { isChecked } = this.state;
        const isLocked = typeof _customResolution === 'number';

        return (
            <Dialog
                hideCancelButton = { true }
                okKey = 'dialog.done'
                onSubmit = { this._onSubmit }
                titleKey = 'videoStatus.callQuality'
                width = 'small'>

                <VideoQualitySlider checked = { isChecked } />

                { !isLocked && (
                    <div className = 'video-quality-preference'>
                        <label className = 'custom-checkbox'>
                            <input
                                checked = { isChecked }
                                onChange = { this._onHandleChange }
                                type = 'checkbox' />
                            <span className = 'checkmark' />
                            {t('settings.savePreference')}
                        </label>
                    </div>
                ) }

            </Dialog>
        );
    }
}

/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code VideoQualityDialog} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _customResolution: ?number,
 *     _preferredVideoQuality: ?number
 * }}
 */
function _mapStateToProps(state) {
    const config = state['features/base/config'];
    const preferredVideoQuality = state['features/video-quality']?.preferredVideoQuality;
    const isLockableContext = config?.interfaceConfig?.applyMeetingSettings === true && !config?.iAmRecorder;
    const rawCustomResolution = isLockableContext ? config?.customResolution : undefined;
    const customResolution
        = typeof rawCustomResolution === 'number' && Number.isInteger(rawCustomResolution)
            ? rawCustomResolution
            : undefined;

    return {
        _customResolution: customResolution,
        _preferredVideoQuality: preferredVideoQuality
    };
}

export default translate(connect(_mapStateToProps)(VideoQualityDialog));

